import * as React from 'react';
import { useButtonsWrapperContext } from '../../buttons-wrapper';
import './Card.scss';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  withBackground?: boolean;
}

export const Card: React.FC<CardProps> = ({ withBackground = true, children, ...rest }) => {
  const { childRef } = useButtonsWrapperContext();

  return (
    <div
      ref={childRef}
      {...rest}
      className={`
        rac-card
        ${rest.className || ''}
        ${withBackground === false ? 'rac-card--transparent' : ''}
      `}
    >
      {children}
    </div>
  );
};

export default Card;
